import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language.service';
import { continueUrl } from 'src/app/utils/safe-redirect';

export type SessionToken = {
  continue_uri: string;
  locale: string;
  email: string;
  isResend: boolean;
  landis: { id: string; name: string }[];
  exp: number;
  iat: number;
  ip: string;
  iss: string;
  sub: string;
  error?: string;
  backUrl?: string;
  backUrlText?: string;
  clientName?: string;
  brandMode?: string;
};

@Component({
    selector: 'app-verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerifyEmailComponent {
  sessionData: SessionToken | null = null;
  state: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    private languageService: LanguageService,
  ) {}
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const sessionToken = params['session_token']; // Replace 'myParam' with your parameter name
      if (!sessionToken) {
        this.router.navigate(['/error']);
      }

      this.state = params['state'];
      if (!this.state) {
        this.router.navigate(['/error']);
      }

      this.sessionData = this.decodeToken(sessionToken);
      this.languageService.setLanguage(
        this.sessionData?.locale || this.languageService.getCurrentLanguage(),
      );
    });
  }

  decodeToken(token: string) {
    try {
      return jwtDecode<SessionToken>(token);
    } catch (Error) {
      return null;
    }
  }

  // Back to this tenant's /continue, never to the token's continue_uri (FW-02).
  resend() {
    window.location.href = continueUrl(this.state, { resend: 'true' });
  }

  getLogo(): string {
    if (this.sessionData?.brandMode) {
      switch (this.sessionData.brandMode) {
        case 'wsa':
          return '../../../assets/footer-icon-3.svg';
        case 'agrola':
          return '../../../assets/agrola-logo.svg';
        case 'barto':
          return '../../../assets/footer-barto-logo.svg';
        case 'fenaco':
        default:
          return 'https://d1zl99f7e5jysh.cloudfront.net/image/992382361685/image_0s145d5fu17vrfk0tv7ovrlj3f/-FJPG%20-S1000x200';
      }
    }

    // Fallback to clientName for backward compatibility
    if (
      this.sessionData?.clientName === 'WSA' ||
      this.sessionData?.clientName === 'WSA-POC'
    ) {
      return '../../../assets/footer-icon-3.svg';
    } else if (
      this.sessionData?.clientName === 'energy club™ Shop' ||
      this.sessionData?.clientName === 'AOP-POC'
    ) {
      return '../../../assets/agrola-logo.svg';
    } else if (
      this.sessionData?.clientName === 'Farmnet Keycloak' ||
      this.sessionData?.clientName === 'barto.ch'
    ) {
      return '../../../assets/footer-barto-logo.svg';
    } else {
      return 'https://d1zl99f7e5jysh.cloudfront.net/image/992382361685/image_0s145d5fu17vrfk0tv7ovrlj3f/-FJPG%20-S1000x200';
    }
  }
}
